import styled from 'styled-components';
import CheckList from '../../../Layout/CheckList/CheckList';

export const StyledChecklist = styled(CheckList)`
  padding-left: 0px;
  margin-left: 0px;
  list-style-type: none;
`;
